import { Control } from './control';
import { Subactivity } from './subactivity';

export class ActivityControl {
  constructor(
    public hash?: string,
    public description?: string,
    public activityStartTxt?: string,
    public subactivity?: Subactivity,
    public control?: Control
  ) { }

  clone() {
    return new ActivityControl(
      this.hash,
      this.description,
      this.activityStartTxt,
      this.subactivity,
      this.control
    );
  }

  get controlName() {
    return this.control ? this.control.name : '';
  }

  get subactivityName() {
    return this.subactivity ? this.subactivity.name : '';
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/activity-control.ts